package io.eqoty.shared.datalayer.objects

import io.eqoty.shared.datalayer.sources.filesystem.CommonFile

sealed interface FormInputImage
data class FormInputImageFile(val file: CommonFile) : FormInputImage
data class FormInputImageUrl(val url: String) : FormInputImage